import i18n from "@/plugins/i18n";

export default function ({ globals }) {
	return {
		namespaced: true,
		state: {
			emailConfirmed: false,
			unableToConfirmVerification: false,
			invalidRequest: false,
			code: "",
			isLoading: false,
		},
		mutations: {
			SET_EMAIL_CONFIRMED(state, value) {
				state.emailConfirmed = value;
			},
			SET_UNABLE_TO_CONFIRM_VERIFICATION(state, value) {
				state.unableToConfirmVerification = value;
			},
			SET_INVALID_REQUEST(state, value) {
				state.invalidRequest = value;
			},
			SET_CODE(state, value) {
				state.code = value ? value.replace(/\s/g, "") : value;
			},
			SET_LOADING(state, value) {
				state.isLoading = value;
			},
		},
		actions: {
			async confirmEmail({ state, commit, dispatch }) {
				try {
					commit("SET_LOADING", true);
					const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
					const confirmResponse = await fetch(`${globalConfig.backends.users}/verify-email/${state.code}`, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					});

					const { result, error = null } = await confirmResponse.json();

					if (error) throw new Error(error.code);

					if (result.success) {
						commit("SET_EMAIL_CONFIRMED", true);
						commit("SET_LOADING", false);
						return;
					}
				} catch (error) {
					const translationExists = i18n.te(`confirmEmail.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";

					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`confirmEmail.errorMessages.${code}`),
					}, { root: true });

					commit("SET_LOADING", false);
					if (error.message === "invalidRequest" || error.message === "generalError") {
						commit("SET_INVALID_REQUEST", true);
						return;
					}
					commit("SET_UNABLE_TO_CONFIRM_VERIFICATION", true);
				}
			},
		},
	};
}
